import { render } from "./Text0.vue?vue&type=template&id=7affc515&scoped=true"
import script from "./Text0.vue?vue&type=script&lang=js"
export * from "./Text0.vue?vue&type=script&lang=js"

import "./Text0.vue?vue&type=style&index=0&id=7affc515&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7affc515"

export default script